import { createContext, useContext, useState, useEffect, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const ClientAuthContext = createContext(null);

export const getClientToken = () => localStorage.getItem("client_token") || "";

export const clientApi = axios.create({ baseURL: API, withCredentials: true });
clientApi.interceptors.request.use((config) => {
  const t = getClientToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const ClientAuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const res = await clientApi.get("/client/me");
      setUser(res.data);
      return res.data;
    } catch {
      setUser(null);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // CRITICAL: returning from OAuth callback. AuthCallback exchanges the session_id first.
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    refresh();
  }, [refresh]);

  const logout = async () => {
    try { await clientApi.post("/client/logout"); } catch { /* ignore */ }
    localStorage.removeItem("client_token");
    setUser(null);
  };

  return (
    <ClientAuthContext.Provider value={{ user, setUser, loading, refresh, logout }}>
      {children}
    </ClientAuthContext.Provider>
  );
};

export const useClientAuth = () => useContext(ClientAuthContext);
